._ConfirmationModal_1cx62_1 ._button_1cx62_1 {
  min-width: 130px;
}
._ConfirmationModal_1cx62_1 ._button_1cx62_1._left_1cx62_4 {
  margin-right: 20px;
}